import React, { useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import {
	Alert,
	Box,
	Button,
	Grow,
	IconButton,
	Paper,
	TextField,
	Typography,
} from '@mui/material';
import { ArrowBack } from '@mui/icons-material';
import { LoadingButton } from '@mui/lab';
import AuthContext from '../Context/Auth/AuthContext';

export default function RestorePassword() {
	const { resetPassword } = useContext(AuthContext);
	const navigate = useNavigate();

	const RegisterSchema = Yup.object().shape({
		email: Yup.string()
			.email('Email no valido.')
			.required('Es un campo requerido.'),
	});

	return (
		<Box
			sx={{
				backgroundColor: '#F2A413',
				height: '100vh',
				width: '100%',
				position: 'fixed',
				left: 0,
				right: 0,
			}}
		>
			<Paper
				sx={{
					backgroundColor: '#FFFFFF',
					height: { xsm: '95vh' },
					borderRadius: '40px 40px 0px 0px',
					position: 'fixed',
					left: 0,
					right: 0,
					bottom: 0,
					zIndex: 0,
					display: 'flex',
					justifyContent: 'flex-start',
					alignItems: 'center',
					flexDirection: 'column',
				}}
			>
				<Box
					sx={{
						width: '90%',
						display: 'flex',
						textAlign: 'center',
						margin: '0 auto',
						flexDirection: 'column',
						marginTop: '20px',
						maxWidth: { sm: '500px' },
					}}
				>
					<Box
						sx={{
							display: 'flex',
							flexDirection: 'row',
							justifyContent: 'flex-start',
							alignItems: 'center',
						}}
					>
						<IconButton
							size='large'
							edge='start'
							color='inherit'
							aria-label='menu'
							onClick={() => {
								navigate(-1);
							}}
						>
							<ArrowBack sx={{ fontSize: { xs: '1.2rem', xsm: '1.5rem' } }} />
						</IconButton>
						<Typography
							variant='h5'
							color='primary'
							fontWeight='bold'
							marginY={2}
						>
							Restablecer contraseña
						</Typography>
					</Box>
					<Typography
						variant='body1'
						color='secondary'
						marginY={2}
						textAlign='start'
					>
						Escribe la direccion de correo electronico al que se enviara el link
						para restablecer tu contraseña.
					</Typography>
					<Formik
						initialValues={{ email: '' }}
						validationSchema={RegisterSchema}
						onSubmit={(values, props) => {
							resetPassword(values, props);
						}}
					>
						{({
							isSubmitting,
							status,
							values,
							errors,
							touched,
							dirty,
							isValid,
						}) => (
							<Form>
								<Field
									type='email'
									required
									margin='dense'
									id='email'
									name='email'
									value={values.email}
									as={TextField}
									label='Correo electrónico'
									fullWidth
									variant='outlined'
									error={errors.email && touched.email}
									helperText={touched.email && errors.email}
									sx={{ marginY: 1 }}
								/>
								<LoadingButton
									disabled={!(isValid && dirty)}
									type='submit'
									sx={{ marginY: 2 }}
									loading={isSubmitting}
									variant='contained'
								>
									Enviar
								</LoadingButton>
								{status?.success && (
									<Grow in={Boolean(status?.success)}>
										<Alert severity='success'>
											<Box
												sx={{
													textAlign: 'start',
													display: 'flex',
													flexDirection: 'column',
												}}
											>
												{status?.success}
												<Button
													onClick={() => {
														navigate('/');
													}}
													color='secondary'
													sx={{ marginY: 2 }}
													variant='outlined'
												>
													Iniciar sesión
												</Button>
											</Box>
										</Alert>
									</Grow>
								)}
								<Grow in={Boolean(status?.error)}>
									<Alert severity='error'>{status?.error}</Alert>
								</Grow>
							</Form>
						)}
					</Formik>
				</Box>
			</Paper>
		</Box>
	);
}
